export const ssrFeatureFlags = ssr => {
  if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) {
    return null;
  }
  try {
    const featureFlags = ssr.getFeatureFlags();
    if (featureFlags) {
      return {
        'ssr:featureFlags': featureFlags
      };
    }
  } catch (e) {}
  return null;
};